/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Macos_1Inputs */

const en_pc_dl_macos_1 = /** @type {(inputs: Pc_Dl_Macos_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the universal .dmg. It runs natively on both Apple silicon and Intel Macs.`)
};

const zh_pc_dl_macos_1 = /** @type {(inputs: Pc_Dl_Macos_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载通用版 .dmg，可在 Apple 芯片和 Intel Mac 上原生运行。`)
};

/**
* | output |
* | --- |
* | "Download the universal .dmg. It runs natively on both Apple silicon and Intel Macs." |
*
* @param {Pc_Dl_Macos_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_macos_1 = /** @type {((inputs?: Pc_Dl_Macos_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Macos_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_macos_1(inputs)
	return zh_pc_dl_macos_1(inputs)
});
export { pc_dl_macos_1 as "pc.dl.macos.1" }